"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _QuotasRecord = _interopRequireDefault(require("../records/QuotasRecord"));

var _quotaActions = require("../actions/quotaActions");

var _apiUtils = require("../utils/apiUtils");

var initialState = new _QuotasRecord.default();

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _quotaActions.GetQuotasActionTypes.REQUEST:
      return state.set('isFetching', true);

    case _quotaActions.GetQuotasActionTypes.SUCCESS:
      return state.set('isFetching', false).addQuotas(action.payload.data.map(_apiUtils.transformQuotaFromApi));

    case _quotaActions.SaveQuotasActionTypes.REQUEST:
      return state.set('isSaving', true);

    case _quotaActions.SaveQuotasActionTypes.SUCCESS:
      if (action.payload.data.postResult) {
        state = state.addQuotas(action.payload.data.postResult.map(_apiUtils.transformQuotaFromApi));
      }

      if (action.payload.data.updateResult) {
        state = state.updateQuotas(action.payload.data.updateResult.updatedQuotas.map(function (rawPartialQuota) {
          var partialQuota = (0, _apiUtils.mapFromPartialQuota)(rawPartialQuota);
          var originalQuota = action.payload.data.updateResult.originalQuotasById.get(partialQuota.get('id'));
          var updatedQuota = originalQuota.merge(partialQuota);
          return {
            originalQuota: originalQuota,
            updatedQuota: updatedQuota
          };
        }));
      }

      return state.set('isSaving', false);

    case _quotaActions.DeleteQuotasActionTypes.SUCCESS:
      return action.payload.data.reduce(function (quotas, quota) {
        return quotas.deleteQuota(quota);
      }, state);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;